import { Contract } from './contract';
import { LeaseAgreementCategory } from './const/enums';

export class OtherContract extends Contract {
  constructor() {
    super(LeaseAgreementCategory.Other);
  }
}
